import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';

const EquipmentSpecsDialog = ({ open, onClose, specs }) => {
    const formatSpecs = (specs) => {
        if (!specs) return [];
        
        // Split the specs string into lines and parse each line
        return specs.split('\n').map((line, index) => {
            // Split the line into columns, handling multiple spaces
            const columns = line.split(/\s{2,}/).filter(col => col.trim());
            
            if (columns.length >= 4) {
                return {
                    feature: columns[0].trim(),
                    featureDesc: columns[1].trim(),
                    option: columns[2].trim(),
                    optionDesc: columns[3].trim(),
                    id: index
                };
            }
            return null;
        }).filter(item => item !== null);
    };

    const formattedSpecs = formatSpecs(specs);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>
                Equipment Specifications
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'primary.light', color: 'primary.contrastText' }}>Feature</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'primary.light', color: 'primary.contrastText' }}>Feature Description</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'primary.light', color: 'primary.contrastText' }}>Option</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'primary.light', color: 'primary.contrastText' }}>Option Description</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {formattedSpecs.map((spec) => (
                                    <TableRow key={spec.id} hover>
                                        <TableCell sx={{ fontWeight: 'medium' }}>{spec.feature}</TableCell>
                                        <TableCell>{spec.featureDesc}</TableCell>
                                        <TableCell sx={{ fontWeight: 'medium' }}>{spec.option}</TableCell>
                                        <TableCell>{spec.optionDesc}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EquipmentSpecsDialog; 